module.exports = __webpack_public_path__ + "img/saved_searches_sync.8ee915cb.jpg";